import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import { getApiErrorMessage } from "../lib/api-error";
import { useAuth } from "../store/auth";

const LoginPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { signIn, user, isLoading } = useAuth();
  const navigate = useNavigate();

  if (isLoading && !user) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <div className="spinner h-10 w-10" />
        <p className="font-semibold text-primary">{t("Загрузка...")}</p>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await signIn(email, password);
      navigate("/");
    } catch (err) {
      setError(getApiErrorMessage(err, "Неверные учетные данные"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden">
      <div
        className="absolute inset-0 -z-10"
        aria-hidden
        style={{
          background:
            "radial-gradient(ellipse 70% 60% at 10% 20%, rgba(79, 70, 229, 0.18), transparent), radial-gradient(ellipse 50% 50% at 90% 80%, rgba(16, 185, 129, 0.12), transparent), #F4F6FB",
        }}
      />

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md modal-panel p-8 md:p-10 animate-fade-up">
          <div className="text-center mb-8">
            <img
              src="/favicon.svg"
              alt=""
              width={56}
              height={56}
              className="rounded-2xl mx-auto mb-5 shadow-glow"
            />
            <h1 className="text-3xl font-bold text-slate-900 tracking-tight mb-2">
              {t("ProТренерофф")}
            </h1>
            <p className="text-app-muted text-[15px]">
              {t("Войдите, чтобы управлять вашим коучинг-бизнесом")}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="p-4 bg-red-500/10 border border-red-500/20 text-red-600 rounded-2xl text-center text-sm font-medium">
                {error}
              </div>
            )}

            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-800 ml-1">
                {t("Электронная почта")}
              </label>
              <input
                type="email"
                name="email"
                autoComplete="username"
                className="input-field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="coach@example.com"
                required
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-slate-800 ml-1">
                {t("Пароль")}
              </label>
              <input
                type="password"
                name="password"
                autoComplete="current-password"
                className="input-field"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            <button
              type="submit"
              className="btn-primary w-full py-4 text-base mt-2"
              disabled={loading}
            >
              {loading ? t("Вход...") : t("Войти")}
            </button>
          </form>
        </div>
      </div>

      <footer className="pb-6 text-center text-sm">
        <a
          href="https://protraineroff.ru/landing/privacy"
          className="font-semibold text-app-muted hover:text-primary"
        >
          {t("Политика персональных данных")}
        </a>
      </footer>
    </div>
  );
};

export default LoginPage;
